import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';

const { colors, spacing, typography } = THEME;

export const styleSheet = StyleSheet.create({
	clearFiltersButton: {
		alignSelf: 'flex-end',
	},
	filter: {
		marginBottom: spacing.md + spacing.xs,
		display: 'grid',
		gap: spacing.sm,
		gridTemplateColumns: 'repeat(auto-fill, minmax(min(272px, 100%), 1fr))',
	},
	filterGroup: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
	},
	label: {
		fontSize: typography.fontSizes.xs,
		fontWeight: typography.fontWeights.bold,
	},
	tabsContainer: {
		display: 'flex',
		borderBottom: `1px solid ${colors.border.main}`,
		marginBottom: spacing.md + spacing.xs,
	},
	tab: {
		borderBottom: '3px solid transparent',
		cursor: 'pointer',
		padding: `${spacing.sm}px ${spacing.md}px`,
		fontSize: typography.fontSizes.sm,
		fontWeight: 500,
	},
	tabActive: {
		borderBottomColor: colors.secondary.main,
	},
	pageRoot: {
		display: 'grid',
		gridTemplateColumns: '1fr auto',
		height: '100%',
		justifyItems: 'center',
	},
	pageContent: {
		width: '100%',
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		overflowY: 'auto',
		overflowX: 'hidden',
	},
	drawer: {
		overflow: 'hidden',
	},
	drawerContent: {
		borderTopLeftRadius: 16,
	},
});
